export default __webpack_public_path__ + "static/media/FriskyFigures.9f6573c4.png";